import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCheckCircle, FiInfo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = ({ title, subtitle, city = "Alberta", definition }) => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-slate-900">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
        <div className="absolute top-20 -left-20 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-block px-4 py-1.5 rounded-full bg-slate-800 border border-slate-700 text-orange-400 text-sm font-semibold mb-6">
              🚀 AlbertaRank™ — The Truth Protocol for Local Growth
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-8 leading-tight">
              {title}
            </h1>
            
            {/* Definition Block for AI Scraping */}
            {definition && (
              <div className="mb-10 p-6 bg-white/5 border border-white/10 rounded-2xl text-left backdrop-blur-sm max-w-3xl mx-auto">
                <div className="flex items-start gap-4">
                  <div className="mt-1 p-2 bg-orange-600/20 rounded-lg text-orange-500">
                    <SafeIcon icon={FiInfo} />
                  </div>
                  <div>
                    <span className="text-xs font-black text-orange-500 uppercase tracking-widest mb-1 block">AI Executive Summary</span>
                    <p className="text-slate-300 text-sm md:text-base leading-relaxed italic">
                      {definition}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <p className="text-lg md:text-xl text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/audit" className="w-full sm:w-auto px-8 py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-bold text-lg transition-all shadow-lg shadow-orange-600/25 flex items-center justify-center gap-2">
                Get Free SEO Audit <SafeIcon icon={FiArrowRight} />
              </Link>
              <Link to="/case-studies" className="w-full sm:w-auto px-8 py-4 bg-slate-800 hover:bg-slate-700 text-white rounded-xl font-semibold border border-slate-700 transition-all">
                View Case Studies
              </Link>
            </div>

            {/* Semantic Triples Section */}
            <div className="mt-12 pt-12 border-t border-white/5 flex flex-wrap justify-center gap-x-8 gap-y-4 text-slate-400 text-sm">
              <span className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-green-500" /> AlbertaRank provides SEO for Calgary Trades.
              </span>
              <span className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-green-500" /> Our systems increase revenue for HVAC companies.
              </span>
              <span className="flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} className="text-green-500" /> Truth Protocol™ secures Map Pack rankings.
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;